<template>
  <div
    v-if="getIsOpen"
    class="modal-backdrop"
  >
    <component
      :is="getComponent"
      ref="modal"
      v-bind="getProps"
      @close="closeModal"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters('modal', ['getIsOpen', 'getComponent', 'getProps']),
  },
  mounted() {
    document.addEventListener('mousedown', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  },
  methods: {
    ...mapActions('modal', ['closeModal']),
    handleClickOutside(e) {
      if (!this.getProps?.closable || e?.button !== 0) return
      const modalEl = this.$refs.modal?.$el || this.$refs.modal
      if (!modalEl) return
      if (!modalEl.contains(e.target)) this.closeModal()
    },
  },
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: var(--Background-Tint, rgba(9, 21, 64, 0.5));
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
}
</style>
